import React, { useEffect, useState } from 'react'
import { Collapse, Icon, message } from 'antd'
import type { IVariable } from '@src/interfaces'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { activateVariables, fetchVariables } from '@src/slices/configuration.slice'

const { Panel } = Collapse

interface IAttributes {
  name: string
  value: string
}

interface ISearchVariables {
  id: number
  attributes: IAttributes[] | null,
  label?: string,
  name: string
}

interface IVariablesCollapse {
  search: ISearchVariables[] | null
}

const VariablesCollapse: React.FC<IVariablesCollapse> = ({
  search
}) => {
  const variables = useSelector(fetchVariables)
  const allVariables = search === null ? variables : search
  const dispatch = useDispatch()
  const [activeKeysCollapse, setActiveKeysCollapse] = useState<string[]>([])
  const height: number | undefined = document.getElementById('card')?.clientHeight;

  const handleCopy = (text: string) => {
    if (navigator?.clipboard) {
      navigator.clipboard.writeText(text)
      message.success('La variable se ha copiado en el portapapeles.')
    }
  }
  
  useEffect(() => {
    if(search?.length){
      const active: string[] = []
      allVariables.forEach((v: any) => {
        active.push(`${v.name}`)
      })
      setActiveKeysCollapse(active)
    } else {
      setActiveKeysCollapse([])
    }
  }, [search])
  

  useEffect(() => {
    return () => {
      dispatch(activateVariables({ visibility: false }))
    }
  }, [])


  return (
    <div className={styles.containerVariables} style={{ height: height ? height - 150 : 0 }}>
      <Collapse
        bordered={false}
        expandIconPosition="left"
        expandIcon={({ isActive }) => <Icon type='right' rotate={isActive ? -90 : 0} />}
        activeKey={activeKeysCollapse}
        onChange={(newActiveKeys: any) => {
          setActiveKeysCollapse(newActiveKeys)
        }}
      >
        {
          allVariables?.length ?
            allVariables.map((variable: IVariable) => {
              const { id, name, attributes, label } = variable
              const parsedLabel = label ? label.split('-') : undefined

              return (
                <Panel header={name} key={`${id}-${name}`} className={styles.panelHeader} forceRender={true} >
                  {parsedLabel && (
                    <div className={styles.label}>
                      <p>{parsedLabel[0]}</p>
                      <p>{parsedLabel[1]}</p>
                    </div>
                  )}
                  {attributes?.map(({ name: attrName, value }) => (
                    <div key={value} className={styles.containerValues} onClick={() => handleCopy(value)}>
                      <p className={styles.panelName}>
                        {attrName}
                      </p>
                      <p className={styles.subPanelValue}>
                        {value}
                      </p>
                    </div>
                  ))}
                </Panel>
              )
            })
            :
            <div>
              <p className={styles.textSearch}>No se han encontrado resultados.</p>
            </div>
        }
      </Collapse>
    </div>
  )
}

export default VariablesCollapse
